export const NOTIFICATION_TYPE = {
  CONTRA_CHEQUE: 'ContraCheque',
  FOLHA_PONTO: 'FolhaPonto',
  STATUS_ATESTADO: 'StatusAtestado',
  EXCECAO: 'Excecao',
} as const;

export function getNotificationRedirectPath(type: string): string | null {
  switch (type) {
    case NOTIFICATION_TYPE.CONTRA_CHEQUE:
      return '/paycheck';
    case NOTIFICATION_TYPE.FOLHA_PONTO:
      return '/time_sheet';
    case NOTIFICATION_TYPE.STATUS_ATESTADO:
      return '/request/track';
    case NOTIFICATION_TYPE.EXCECAO:
      return '/request/medical-certificate';
    default:
      return null;
  }
}
